import { Component, OnInit } from '@angular/core';
import { LifetimeNetLossThresholdsService } from './lifetime-net-loss-thresholds.service';
import { LifetimeRiskNetLossThresholdDTO } from './lifetime-net-loss-thresholds';

@Component({
  selector: 'app-lifetime-net-loss-thresholds',
  templateUrl: './lifetime-net-loss-thresholds.component.html',
  styleUrls: ['./lifetime-net-loss-thresholds.component.scss'],
  standalone: false,
})
export class LifetimeNetLossThresholdsComponent implements OnInit {
  constructor(private service: LifetimeNetLossThresholdsService) {}

  thresholdsByRisk?: LifetimeRiskNetLossThresholdDTO[];

  ngOnInit(): void {
    this.service.get().subscribe((params) => (this.thresholdsByRisk = params));
  }
}
